import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

declare global {
  interface Date {
    toFormattedString(): string;
    toFormattedDateTimeString(): string;
    toAgoString(): string;
  }
}

/**
 * Dates are rendered in a fixed `dd.MM.yyyy` form rather than through `toLocaleDateString`,
 * which follows whatever language the browser happens to be set to. An operator reading a
 * license expiry — or sending a screenshot to support — should see the same thing everyone
 * else does.
 *
 * The clock is still the viewer's: the components below read local date parts, so a
 * timestamp appears in the browser's timezone while the server stores and serves UTC.
 */
Date.prototype.toFormattedString = function () {
  try {
    if (isNaN(this.getTime())) throw new Error('Invalid date');

    const day = this.getDate().toString().padStart(2, '0');
    const month = (this.getMonth() + 1).toString().padStart(2, '0');

    return `${day}.${month}.${this.getFullYear()}`;
  } catch (error) {
    console.error('Date.toFormattedString:', error);
    return 'Invalid date';
  }
};

Date.prototype.toFormattedDateTimeString = function () {
  try {
    if (isNaN(this.getTime())) throw new Error('Invalid date');

    const hours = this.getHours().toString().padStart(2, '0');
    const minutes = this.getMinutes().toString().padStart(2, '0');

    return `${this.toFormattedString()} ${hours}:${minutes}`;
  } catch (error) {
    console.error('Date.toFormattedDateTimeString:', error);
    return 'Invalid date';
  }
};

Date.prototype.toAgoString = function () {
  try {
    if (isNaN(this.getTime())) throw new Error('Invalid date');

    return dayjs().to(this);
  } catch (error) {
    console.error('Date.toAgoString:', error);
    return 'Invalid date';
  }
};

export { };
